import { jwtDecode } from "jwt-decode";
import { clearSessionData } from "./utils";

export function loginUser(token) {
    localStorage.setItem("userData", JSON.stringify({ token }));
}

export function logoutUser() {
    const userPortalUrl = getUserPortalUrl();
    localStorage.removeItem("userData");
    clearSessionData();
    return userPortalUrl;
}

export function isUserLoggedIn() {
    return !!getUserToken();
}

/**
 * @returns {"ADMIN" | "STAFF" | "FAMILY" | null}
 */
export function getUserRole() {
    return getUserToken()?.access;
}

export function getUserEmail() {
    return getUserToken()?.email;
}

export function getUserAccountStatus() {
    if (getUserData()?.statusOverride) {
        return getUserData().statusOverride;
    }

    return getUserToken()?.accountStatus;
}

export function setUserAccountStatusOverride(statusOverride) {
    setUserData({ ...getUserData(), statusOverride });
}

export function getUserPortalUrl(role = getUserRole()) {
    return {
        "ADMIN": "/admin-portal",
        "STAFF": "/staff-portal",
        "FAMILY": "/family-portal"
    }[role] ?? "/";
}

/**
 * Gets the current user's token string, or null if the user is not logged in.
 * This function should only be called from `index.jsx` to provide a token for the axios request interceptor.
 * @returns {string | null}
 */
export function getUserTokenString() {
    return getUserData()?.token;
}

function getUserData() {
    return JSON.parse(localStorage.getItem("userData"));
}

function setUserData(data) {
    localStorage.setItem("userData", JSON.stringify(data));
}

/**
 * @returns {{ email: string, access: "ADMIN" | "STAFF" | "FAMILY", accountStatus?: string }}
 */
function getUserToken() {
    try {
        return jwtDecode(getUserTokenString());
    } catch {
        return null;
    }
}